import {
  ButtonWithGradient,
  PageLayout,
  Separator,
  Text,
  ToastMessage,
} from "components";
import { AutoCompleteItem, FormItem, SelectFormItem } from "../components";
import { AccountStyle, FormRowStyle } from "../styles";
import Timezones from "../assets/timezones.json";
import { useContext, useState } from "react";
import { UserContext } from "context";
import { UPDATE_PREFRENCES } from "apollo";
import { useMutation } from "@apollo/client";

const options: {
  value: string;
  label: string;
}[] = [];
Timezones.forEach((timezone) => {
  timezone.utc.forEach((utc) => {
    const exists = options.find((option) => option.value === utc);
    if (!exists) {
      options.push({
        label: `${utc} ${timezone.text.split(" ")[0]}`,
        value: utc,
      });
    }
  });
});
export const MyAccountScreen: React.FC = () => {
  const { state: userState } = useContext(UserContext);
  const [firstName, setFirstName] = useState(
    userState?.preferences?.firstName || userState?.firstName || "",
  );
  const [lastName, setLastName] = useState(
    userState?.preferences?.lastName || userState?.lastName || "",
  );
  const [primaryLocation, setPrimaryLocation] = useState(
    userState?.preferences?.location || userState?.tempLocation || "",
  );
  const [secondaryLocation, setSecondaryLocation] = useState(
    userState?.preferences?.secondaryLocation || "",
  );
  const [timezone, setTimezone] = useState(
    userState?.preferences?.timezone || userState?.settings?.timeZone || "",
  );
  const [showToast, setShowToast] = useState(false);

  const [updateUser] = useMutation(UPDATE_PREFRENCES);

  const handleLocationChange = (value: string) => setPrimaryLocation(value);
  const handleFirstNameChange = (value: string) => setFirstName(value);
  const handleLastNameChange = (value: string) => setLastName(value);
  const handleSecondaryLocationChange = (value: string) =>
    setSecondaryLocation(value);
  const handleTimezoneChange = (value: string) => setTimezone(value);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateUser({
      variables: {
        data: {
          firstName,
          lastName,
          location: primaryLocation,
          secondaryLocation,
          timezone,
        },
      },
    })
      .then(() => {
        setShowToast(true);
      })
      .catch(() => {});
  };

  return (
    <PageLayout title="My account | Multiplayer">
      <div className={AccountStyle}>
        <ToastMessage
          show={showToast}
          handleShow={setShowToast}
          success
          duration={3000}
        />
        <Text.H2>My account</Text.H2>
        <Text.H4 color="seconday">
          You can change your informations here to improve te way Multiplayer
          works for you
        </Text.H4>
        <Separator.Horizontal spacing={10} />

        <form onSubmit={handleSubmit}>
          <FormItem
            label="Username"
            placeholder="Your username"
            value={userState?.email}
            readOnly
            onChange={() => {}}
          />
          <Separator.Horizontal spacing={4} />
          <div className={FormRowStyle}>
            <FormItem
              label="First name"
              placeholder="Your first name"
              value={firstName}
              onChange={handleFirstNameChange}
            />
            <FormItem
              label="Last name"
              placeholder="Your last name"
              value={lastName}
              onChange={handleLastNameChange}
            />
          </div>
          <div className={FormRowStyle}>
            <AutoCompleteItem
              label="Your primary location"
              onChange={handleLocationChange}
              value={primaryLocation}
              placeholder="Fill your primary location"
            />
            <AutoCompleteItem
              label="Your secondary location"
              onChange={handleSecondaryLocationChange}
              value={secondaryLocation}
              placeholder="Fill your secondary location"
            />
          </div>
          <Separator.Horizontal spacing={2} />
          <SelectFormItem
            label="Timezone"
            options={options}
            defaultValue={options.find(
              (option) =>
                option.value.toLowerCase() === timezone?.toLowerCase(),
            )}
            onChange={handleTimezoneChange}
          />

          <Separator.Horizontal spacing={6} />
          <ButtonWithGradient
            type="submit"
            style={{
              height: "40px",
            }}
          >
            Save changes
          </ButtonWithGradient>
        </form>
      </div>
    </PageLayout>
  );
};
